import { render, staticRenderFns } from "./SearchEncontesa.vue?vue&type=template&id=1830948f&scoped=true"
import script from "./SearchEncontesa.vue?vue&type=script&lang=js"
export * from "./SearchEncontesa.vue?vue&type=script&lang=js"
import style0 from "./SearchEncontesa.vue?vue&type=style&index=0&id=1830948f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830948f",
  null
  
)

export default component.exports